import { makeStyles } from '@material-ui/core';
import { maxWidth } from '@material-ui/system';
import React from 'react';

const useStyles = makeStyles((theme) => ({
	background: {
		position: 'absolute',
		top: 0,
		width: '100vw',
		height: '100vh',
		background: `url("/images/background.png")`,
	},
	logoSection: {
		textAlign: 'center',
		marginTop: '35vh',
		'& img': {
			width: '60vw',
			maxHeight: '35vh',
			maxWidth: '450px',
		},
	},
	footer: {
		position: 'absolute',
		textAlign: 'center',
		bottom: '5vh',
		left: 0,
		right: 0,
		'& img': {
			width: '27vw',
			maxHeight: '30vh',
			maxWidth: '180px',
		},
	},
}));

const Splash: React.FC<any> = (props) => {
	const classes = useStyles();
	return (
		<div className={classes.background}>
			<div className={classes.logoSection}>
				<img src="/images/logo.webp" />
			</div>

			<div className={classes.footer}>
				<img src="/images/youstarter.png" />
			</div>
		</div>
	);
};

export default Splash;
